module.exports = __webpack_public_path__ + "static/media/arrow-left-circle.c724673c.svg";